import React from "react";

export default function BrandSvg({ name }) {
  return (
    <svg
      width="190"
      height="26"
      color="var(--pf-t--global--text--color--regular)"
    >
      <rect
        x="1"
        y="7"
        rx="2"
        ry="2"
        width="42"
        height="18"
        fill="transparent"
        stroke="currentColor"
        strokeWidth="1"
      />

      <text
        // fontWeight="bold"
        x="4"
        y="20"
        fontSize="12"
        fill="currentColor"
      >
        {name}
      </text>

      <rect
        x="48"
        y="7"
        rx="2"
        ry="2"
        width="18"
        height="18"
        fill="transparent"
        stroke="currentColor"
        strokeWidth="1"
      />

      <text
        // fontWeight="bold"
        x="51"
        y="20"
        fontSize="12"
        fill="currentColor"
      >
        TI
      </text>

      <rect
        x="71"
        y="7"
        rx="2"
        ry="2"
        width="20"
        height="18"
        fill="transparent"
        stroke="currentColor"
        strokeWidth="1"
      />

      <text
        // fontWeight="bold"
        x="73"
        y="20"
        fontSize="12"
        fill="currentColor"
      >
        TP
      </text>
    </svg>
  );
}
